import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .LeftMenu {
    min-width: 240px;

    @include respond-to(md) {
      z-index: 30;
      position: fixed;
      width: 250px;
      max-height: 100vh;
      height: 100%;
      padding: 0 0 50px;
      top: 0;
      left: ${isRTL ? '' : '0'};
      left: ${isRTL ? '0' : ''};
      transform: translateX(${isRTL ? '200%' : '-200%'});
      transition: all 0.5s ease;
      overflow-y: auto;
      box-shadow: 3px 0 5px 0 rgba(0, 0, 0, 0.05);
      background-color: #212121;
      color: #ffffff;

      &.opened {
        transform: translateX(0);
      }
    }

    &__mobile-block {
      display: none;
      height: 80px;
      margin-bottom: 20px;
      align-items: center;
      text-transform: uppercase;
      font-size: 11px;
      letter-spacing: 0.3px;
      font-weight: 500;

      @include respond-to(md) {
        display: flex;
      }
    }

    &__link {
      position: relative;
      display: flex;
      align-items: center;
      padding: ${isRTL ? '8px 20px 8px 15px' : '8px 15px 8px 20px'};
      cursor: pointer;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 3px;
        height: 100%;
        transition: all 0.4s ease;
        transform: scale(0);
        opacity: 0;
        background-color: #3ec4df;
      }

      &:not(.active):hover:after {
        transform: scale(1);
        opacity: 1;
      }

      &.active {
        background-color: #ffffff;
        border-left: 3px solid #3ec4df;
        border-radius: 7px;

        @include respond-to(md) {
          background-color: transparent;
        }
      }
    }

    &__icon {
      width: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: ${isRTL ? '0' : '15px'};
      margin-left: ${isRTL ? '15px' : '0'};

      .svgFill,
      .svgNoFill .fill {
        fill: #5d647d;

        @include respond-to(md) {
          fill: #ffffff;
        }
      }
    }

    &__link_title {
      position: relative;
    }

    .Tooltip {
      max-width: 255px !important;

      &__text {
        position: absolute;
        width: calc(100% + 39px);
        height: 100%;
        top: 0;
        left: ${isRTL ? 'unset' : '-39px'};
        right: ${isRTL ? '-39px' : 'unset'};
      }
    }
  }
`;

export { staticStyles };
